import React from 'react';
import Helmet from 'react-helmet';

import Config from 'Config';

import Header from './Header';
import Footer from './Footer';

const Studio94Layout: React.SFC<{}> = (props) => {
  return (
    <div className="studio94">
      <Helmet
        defaultTitle={Config.site.title}
        titleTemplate={Config.site.titleTemplate}
      />
      <Header {...props} />
      <div style={{ minHeight: '100%' }}>
        {props.children}
      </div>
      <Footer />
    </div>
  );
};

export default Studio94Layout;
